/**
 * Modello centralizzato per le rotte dell'applicazione
 * Utilizzare queste costanti invece di stringhe hardcoded per garantire type-safety e manutenibilità
 *
 * @example
 * // In un componente TypeScript:
 * import { AppRoutes } from '@core/models/routes.model';
 *
 * // Navigazione programmatica
 * this.router.navigate([AppRoutes.DASHBOARD]);
 *
 * // In un template HTML:
 * <a [routerLink]="AppRoutes.DASHBOARD">Dashboard</a>
 */
export class AppRoutes {
  // Rotte principali
  static readonly MAIN_ROUTE = 'nfarm';
  static readonly APP = 'app';
  static readonly LAUNCHER = 'launcher';
  static readonly DASHBOARD = 'dashboard';
  // Unico "app" attivo in Nova Suite: usato per saltare il launcher e atterrare
  // direttamente sulla vetrina piani dopo il login.
  static readonly DEFAULT_APP_CODE = 'nfarm';
  static readonly AZIENDE = 'companies';
  static readonly OPERATORS = 'operators';
  static readonly PROCURATORI = 'attorneys';
  static readonly ACQUISTI = 'purchases';
  /** Fatture e note di credito, sotto l'area acquisti. */
  static readonly FATTURE = 'invoices';
  static readonly CARRELLO = 'cart';
  static readonly CHECKOUT = 'checkout';
  /** Ritorno dal pagamento con carta, sotto il checkout. */
  static readonly PAYMENT_RETURN = 'conferma';
  static readonly PROFILE = 'profile';
  /** Dichiarazione di accessibilità: pubblica, raggiungibile dal piè di pagina. */
  static readonly ACCESSIBILITY = 'accessibilita';
  static readonly NOT_FOUND = 'not-found';
  // Rotte di autenticazione
  static readonly AUTH = 'auth';
  static readonly AUTH_LOGIN = 'login';
  static readonly AUTH_FORGOT_PASSWORD = 'forgot-password';
  static readonly AUTH_REGISTER = 'register';
  /**
   * Destinazione del link di verifica email inviato da Odoo
   * (`/confirm-email?token=...`): sta al primo livello perché il link arriva
   * sul dominio nudo, non sotto `/auth`.
   */
  static readonly CONFIRM_EMAIL = 'confirm-email';
  /**
   * Destinazione del link di reset password inviato da Odoo
   * (`/reset-password?token=...`): stesso schema di CONFIRM_EMAIL.
   */
  static readonly RESET_PASSWORD = 'reset-password';

  // Rotta root
  static readonly ROOT = '/';
}
